/**
 * Based on a ISO 639 language code, make an educated guess for the best territory in ISO 3166.
 *
 * @param {String} language The language in ISO 639
 * @returns {String} The locale in ISO 3166
 */
export const languageToLocale = (language) => {
	switch (language) {
	case 'de':
		return 'de_DE';
	case 'en':
		return 'en_US';
	case 'fr':
		return 'fr_FR';
	case 'id':
		return 'id_ID';
	case 'it':
		return 'it_IT';
	case 'es':
		return 'es_ES';
	case 'nl':
		return 'nl_NL';
	case 'nb':
		return 'nb_NO';
	case 'sv':
		return 'sv_SE';
	case 'pt':
		return 'pt_PT';
	case 'tr':
		return 'tr_TR';
	case 'ru':
		return 'ru_RU';
	case 'ja':
		return 'ja_JP';
	case 'zh':
		return 'zh_CN';
	default:
		return language;
	}
};